<!-- Своя разметка сообщения вместо штатной (кнопку закрытия PrimeNG рисует сам, вне шаблона): в Aura кнопка закрытия
     абсолютная поверх правого верхнего угла, и длинный summary/detail уходил под неё. Блоку текста — внешний отступ
     справа под кнопку, длинное слово переносится в любом месте. Вид штатный: цвет и фон — от плашки, размеры и
     начертание — токены Aura toast (--p-toast-*), цвет detail — токен своей severity (toastDetailColor). -->
<p-toast [life]="5000">
  <ng-template #message let-message>
    <i [class]="'pi ' + toastIcon(message?.severity) + ' shrink-0 size-(--p-toast-icon-size) text-(length:--p-toast-icon-size) m-(--p-toast-icon-margin)'"
       aria-hidden="true"></i>
    <div class="flex flex-col flex-auto min-w-0 gap-(--p-toast-text-gap) me-5 wrap-anywhere">
      <div class="font-(--p-toast-summary-font-weight) text-(length:--p-toast-summary-font-size)">{{ message?.summary }}</div>
      <div [class]="'font-(--p-toast-detail-font-weight) text-(length:--p-toast-detail-font-size) ' + toastDetailColor(message?.severity)">{{ message?.detail }}</div>
    </div>
  </ng-template>
</p-toast>
<p-confirmdialog styleClass="w-[28rem] max-w-[calc(100vw-2rem)]" baseZIndex="1000"></p-confirmdialog>
<!-- Оболочка есть всегда, меню и верхнюю полосу она показывает только после входа и не на странице входа:
     router-outlet — один проецируемый узел этого шаблона и не пересоздаётся при входе и выходе
     (см. core/shell/shell.component.ts). -->
<app-shell [chrome]="chrome()">
  <router-outlet></router-outlet>
</app-shell>
